<script setup>
    import { defineProps } from 'vue'
    import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/solid'
    import RenderlessPagination from './RenderlessPagination.vue';

    const props = defineProps(['componentClass', 'currentPage', 'pagination', 'gotoPage'])
</script>

<template>
    <RenderlessPagination v-bind="props" v-slot="{ needPagination, pagination, nextPage, prevPage, gotoPage }">
        <div class="flex flex-1 px-4 py-4 items-center justify-between" :class="componentClass">
            <div class="">
                <p class="text-sm text-gray-700">
                Showing
                {{ ' ' }}
                <span class="font-medium">{{pagination.page * pagination.limit + 1}}</span>
                {{ ' ' }}
                to
                {{ ' ' }}
                <span class="font-medium">{{ Math.min((pagination.page + 1) * pagination.limit, pagination.count) }}</span>
                {{ ' ' }}
                of
                {{ ' ' }}
                <span class="font-medium">{{ pagination.count }}</span>
                {{ ' ' }}
                results
                </p>
            </div>
            <div>
                <nav v-if="needPagination" class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                    <button @click="prevPage" 
                        :class="pagination.prev ? 'relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50'
                                                : 'relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-300 hover:bg-gray-50'">
                        <span class="sr-only">Previous</span>
                        <ChevronLeftIcon class="h-5 w-5" aria-hidden="true" />
                    </button>
                    <!-- Current: "z-10 bg-sky-50 border-sky-500 text-sky-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" -->
                    <button v-for="page in pagination.pages" :key="page" @click="gotoPage(page)" aria-current="page" 
                        :class="(page === props.currentPage) ? 'z-10 bg-sky-50 border-sky-500 text-sky-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium'
                                                        : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium'"> 
                        {{ page != null && page >= 0 ? page+1 : '...' }} 
                    </button>
                    <button @click="nextPage" 
                        :class="pagination.next ? 'relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50'
                                                : 'relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-300 hover:bg-gray-50'">
                        <span class="sr-only">Next</span>
                        <ChevronRightIcon class="h-5 w-5" aria-hidden="true" />
                    </button>
                </nav>
            </div>
        </div>
    </RenderlessPagination>
</template>